import { z } from "zod";
import { readPolicyConfig, type ReadPolicy } from "./readPolicy";
import { legalStatusSchema } from "./legalSchemas";

import { apiClient } from "@/api/client";
import { subscriptionStateSchema } from "@/api/subscription";

export const profileSchema = z.object({
  id: z.string().uuid(),
  telegram_id: z.number().nullable().optional(),
  username: z.string().nullable().optional(),
  auth_email: z.string().nullable().optional(),
  anthropometry: z.record(z.unknown()).default({}),
  goals: z.record(z.unknown()).default({}),
  subscription: subscriptionStateSchema.optional(),
  subscription_status: z.string(),
  stars_balance: z.number().default(0),
  onboarding_completed: z.boolean().default(false),
  legal_status: legalStatusSchema.nullable().optional(),
});

export type UserProfile = z.infer<typeof profileSchema>;

export async function fetchMyProfile(timeoutMs?: number, policy?: ReadPolicy): Promise<UserProfile> {
  const { data } = await apiClient.get("/users/me", { timeout: timeoutMs, ...readPolicyConfig(policy) });
  return profileSchema.parse(data);
}

export async function updateMyProfile(input: {
  anthropometry?: Record<string, unknown>;
  goals?: Record<string, unknown>;

}): Promise<UserProfile> {
  const { data } = await apiClient.put("/users/me", input);
  return profileSchema.parse(data);
}
